import type {
  FinanceInfo,
  FinanceLink,
} from '../../../../../components/PageWrappers/AdDetails/types';
import type { PricingIndicatorStatus } from '../../../../../components/PricingIndicator/PricingIndicatorIconText/PricingIndicatorIconText.typed';
import { generateFinanceLink } from '../../../../../components/PageWrappers/AdDetails/helpers';

const PRICING_INDICATOR_TRACKING_NAME: Record<PricingIndicatorStatus, string> =
  {
    ABOVE: 'above average',
    SAME: 'at average',
    BELOW: 'below average',
  };

type BuildFinanceUrlArgs = {
  financeLink?: FinanceLink;
  financeInfo?: FinanceInfo | null;
  priceIndicator?: { state: PricingIndicatorStatus };
  userId?: string;
  sellerType?: string;
  section?: string;
  location?: string;
  mainSection?: string;
  trustedDealer?: boolean;
};

export const buildFinanceUrl = ({
  financeLink,
  financeInfo,
  priceIndicator,
  userId,
  sellerType,
  section,
  location,
  mainSection,
  trustedDealer,
}: BuildFinanceUrlArgs) => {
  const base =
    financeLink?.url || (financeInfo && generateFinanceLink(financeInfo)) || '';
  if (!base) return base;

  const [path, existingQuery = ''] = base.split('?');
  const search = new URLSearchParams(existingQuery);
  if (priceIndicator?.state)
    search.set(
      'pricingIndicator',
      PRICING_INDICATOR_TRACKING_NAME[priceIndicator.state],
    );
  if (userId) search.set('userId', userId);
  if (sellerType) search.set('sellerType', sellerType);
  if (section) search.set('section', section);
  if (location) search.set('location', location);
  if (mainSection) search.set('mainSection', mainSection);
  if (trustedDealer !== undefined)
    search.set('trustedDealer', String(trustedDealer));

  const query = search.toString();
  return query ? `${path}?${query}` : path;
};
